// ----------------------------------------------------------------------
// <copyright file="Izenda.SourceDestinationContainer.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * SourceDestinationContainer component
 */
!(function() {


  require('share/utils/Izenda.StringUtilities');
  var React = require('react');
  var observer = require('mobx-react').observer;
  var connect = require('share/enhancers/Izenda.Connect');
  var SourceTree = require('../SourceTree/Izenda.SourceTree');
  var classnames = require('classnames');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  const { find, get } = require('lodash/fp');

  /**
   * Selection data source tree that shows available and selected query source
   * in two data source tree UI.
   */
  var SourceDestinationContainer = React.createClass({
    propTypes: {
      store: React.PropTypes.object.isRequired
    },
    render: function() {
      var props = this.props;
      var store = this.props.store;
      var tenantDetail = store.item.selectedTenant;
      var localization = props.localization;

      var source = find({ id: store.item.sourceId }, store.tenantList);
      var sourceTitle = String.format(
        '{0}: {1}',
        localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_LABEL_SOURCE'),
        source.name
      );
      var destinationTitle = String.format(
        '{0}: {1}',
        localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_LABEL_DESTINATION'),
        tenantDetail.tenantName
      );

      return (
        <GridLayout>
          <GridLayout.Row className="col-md-12 text-bold">
            {localization.getText('COPY_MANAGEMENT_LABEL_DATE_MODEL_COMPARISON')}
          </GridLayout.Row>
          <GridLayout.Row className="workspace-container">
            <GridLayout.Col cols={6}>
              <SourceTree
                store={store}
                tree={tenantDetail.querySourceTree}
                isTenant={true}
                title={sourceTitle}
                showSelected={showNode}
                showFieldNode={true}
                showIcon={true}
                hideDropdown={true}
                className="izenda-advancedCopyTree"
              />
            </GridLayout.Col>
            <GridLayout.Col cols={6}>
              <SourceTree
                store={store}
                tree={tenantDetail.destinationQuerySourceTree}
                isDestination={true}
                title={destinationTitle}
                showFieldNode={true}
                hideDropdown={true}
                className="izenda-advancedCopyTree"
              />
            </GridLayout.Col>
          </GridLayout.Row>
        </GridLayout>
      );

      function showNode(obj) {
        // obj is child of FieldNode >> its status depends on its parent-node
        return get('parentNode.isFieldNode', obj) ? isShow(obj.parentNode) : isShow(obj);

        function isShow(node) {
          // always show group item: table, view, stored proc...
          if (get('initData.group', obj) || get('dataSource.group', obj)) {
            return true;
          }
          node = node.initData || node;
          return node.checked || node.belongToCopiedReport;
        }
      }
    }
  });

  module.exports = connect()(SourceDestinationContainer);
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/CopyManagement/WorkspaceDetail/AdvancedCopy/Izenda.SourceDestinationContainer.jsx